var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, state } from 'lit/decorators.js';
import { dedupeMixin } from '@open-wc/dedupe-mixin';
function ResizableImplementation(Class, tabletWidth = 768, desktopWidth = 1024) {
    class ResizableElement extends Class {
        constructor() {
            super(...arguments);
            this.isMobile = false;
            this.isTablet = false;
            this.isDesktop = false;
            this.windowWidth = 0;
            this.windowHeight = 0;
            this.formFactor = '';
            this.onResizeHandler = this.onResize.bind(this);
        }
        connectedCallback() {
            super.connectedCallback();
            if (window) {
                window.addEventListener('resize', this.onResizeHandler);
                this.onResize();
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            if (window) {
                window.removeEventListener('resize', this.onResizeHandler);
            }
        }
        onResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            this.isMobile = window.innerWidth < tabletWidth;
            this.isTablet = window.innerWidth < desktopWidth;
            this.isDesktop = !this.isMobile && !this.isTablet;
            this.formFactor = (() => {
                if (this.isMobile)
                    return 'mobile';
                if (this.isTablet)
                    return 'tablet';
                if (this.isDesktop)
                    return 'desktop';
                return '';
            })();
        }
    }
    __decorate([
        state()
    ], ResizableElement.prototype, "isMobile", void 0);
    __decorate([
        state()
    ], ResizableElement.prototype, "isTablet", void 0);
    __decorate([
        state()
    ], ResizableElement.prototype, "isDesktop", void 0);
    __decorate([
        state()
    ], ResizableElement.prototype, "windowWidth", void 0);
    __decorate([
        state()
    ], ResizableElement.prototype, "windowHeight", void 0);
    __decorate([
        property({ reflect: true, attribute: 'form-factor' })
    ], ResizableElement.prototype, "formFactor", void 0);
    return ResizableElement;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Resizable = dedupeMixin(ResizableImplementation);
